// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimValueDetails = t.struct({
    coreValues: t.maybe(t.Number),
    creditMemoNumber: t.String,
    currency: KeyValuePair,
    deductible: t.maybe(t.Number),
    exchangeRate: t.maybe(t.Number),
    laborAdditive: t.maybe(t.Number),
    laborTotal: t.maybe(t.Number),
    laborValue: t.maybe(t.Number),
    localCurrency: t.maybe(KeyValuePair),
    nonTravel: t.maybe(t.Number),
    onShelfCost: t.maybe(t.Number),
    otherCreditTotal: t.maybe(t.Number),
    partAdditive: t.maybe(t.Number),
    partValues: t.maybe(t.Number),
    partsTotal: t.maybe(t.Number),
    tax: t.maybe(t.Number),
    taxInLocalCurrency: t.maybe(t.Number),
    totalAmount: t.maybe(t.Number),
    totalAmountInLocalCurrency: t.maybe(t.Number),
    totalAmountReimbursed: t.maybe(t.Number),
    totalAmountReimbursedInLocalCurrency: t.maybe(t.Number),
    travel: t.maybe(t.Number)
}, {
    name: 'ClaimValueDetails',
    strict: true
});

export const getDefaultState = () => new ClaimValueDetails({
    coreValues: null,
    creditMemoNumber: '',
    currency: getKeyValueDefaultState(),
    deductible: null,
    laborAdditive: null,
    laborTotal: null,
    laborValue: null,
    localCurrency: getKeyValueDefaultState(),
    nonTravel: null,
    onShelfCost: null,
    otherCreditTotal: null,
    partAdditive: null,
    partValues: null,
    partsTotal: null,
    tax: null,
    totalAmount: null,
    totalAmountReimbursed: null,
    travel: null
});

export default ClaimValueDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-value-details.js